<template>
<main class="c-vacancy-page">
    <Container>
        <div class="u-spinner" v-if="loading">Loading...</div>
        <template v-else>
            <Row>
                <Column :md="16">
                    <Heading :level="1" noMarginTop>{{model.title}}</Heading>
                </Column>
            </Row>

            <Row>
                <Column :md="16">
                    <div v-html="this.decodeHtmlEntities(model.content)" class="c-article-page__main-body"></div>
                </Column>
                <Column :offsetMd="1" :md="4">
                    <div class="row c-article-page__categories">
                        <div class="o-col col-xs-24">
                            <div class="o-heading o-heading--category">Country</div>
                        </div>
                        <div class="o-col  col-xs-12 col-md-24">{{model.DepartmentLabel}}</div>
                    </div>
                    <div class="row c-article-page__categories ">
                        <div class="o-col col-xs-24">
                            <div class="o-heading o-heading--category">Location</div>
                        </div>
                        <div class="o-col  col-xs-12 col-md-24">{{model.location.name}}</div>
                    </div>
                    <a :href="model.absolute_url" class="o-button c-hero__button o-button--large apply-job-listing">Apply here</a>
                </Column>
            </Row>

        </template>
    </Container>
</main>
</template>

<script>
import api from '@/Scripts/api/api';

export default {
    data() {
        return {
            loading: true,
            model: null
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            var params = {id: this.$route.query.id};
            api.getVacancyDetailedData(params).then(response => {
                this.model = JSON.parse(response.data);
                this.loading = false;
            });
        },

        decodeHtmlEntities(encodedString) {
            const parser = new DOMParser();
            const decoded = parser.parseFromString(encodedString, 'text/html');
            return decoded.documentElement.textContent;
        },
    }

};
</script>

<style lang="scss">
    a.apply-job-listing {
        margin-top: 2em;
    }

</style>
